module.exports = __webpack_public_path__ + "img/11n.fbf3840c.png";